<template>
  <hr class="my-2 border-t border-gray-200">
</template>
